// Sport-specific position data
export const SPORT_POSITIONS: { [key: string]: string[] } = {
  'Football': [
    'Quarterback', 'Running Back', 'Fullback', 'Wide Receiver', 'Tight End',
    'Center', 'Guard', 'Tackle', 'Defensive End', 'Defensive Tackle',
    'Linebacker', 'Cornerback', 'Safety', 'Kicker', 'Punter', 'Long Snapper'
  ],
  'Basketball': [
    'Point Guard', 'Shooting Guard', 'Small Forward', 'Power Forward', 'Center',
    'Sixth Man', 'Backup Point Guard', 'Backup Shooting Guard', 'Backup Small Forward',
    'Backup Power Forward', 'Backup Center', 'Starting Five', 'Bench Player'
  ],
  'Baseball': [
    'Pitcher', 'Catcher', 'First Base', 'Second Base', 'Third Base', 'Shortstop',
    'Left Field', 'Center Field', 'Right Field', 'Designated Hitter'
  ],
  'Soccer': [
    'Goalkeeper', 'Center Back', 'Left Back', 'Right Back', 'Wing Back',
    'Defensive Midfielder', 'Central Midfielder', 'Attacking Midfielder',
    'Left Midfielder', 'Right Midfielder', 'Left Winger', 'Right Winger',
    'Striker', 'Center Forward', 'Second Striker'
  ],
  'Hockey': [
    'Goalie', 'Left Defenseman', 'Right Defenseman', 'Left Wing', 'Right Wing', 'Center'
  ],
  'Volleyball': [
    'Setter', 'Outside Hitter', 'Middle Blocker', 'Opposite Hitter', 'Libero', 'Defensive Specialist'
  ],
  'Tennis': [
    'Singles Player', 'Doubles Player'
  ],
  'Swimming': [
    'Freestyle', 'Backstroke', 'Breaststroke', 'Butterfly', 'Individual Medley', 'Distance', 'Sprint'
  ],
  'Track & Field': [
    'Sprinter', 'Middle Distance', 'Long Distance', 'Hurdler', 'High Jump', 'Long Jump',
    'Pole Vault', 'Triple Jump', 'Shot Put', 'Discus', 'Hammer Throw', 'Javelin'
  ],
  'Softball': [
    'Pitcher', 'Catcher', 'First Base', 'Second Base', 'Third Base', 'Shortstop',
    'Left Field', 'Center Field', 'Right Field', 'Designated Player'
  ],
  'Lacrosse': [
    'Goalie', 'Defenseman', 'Long-Stick Midfielder', 'Midfielder', 'Attackman'
  ],
  'Water Polo': [
    'Goalkeeper', 'Center Back', 'Driver', 'Point', 'Flat', 'Center Forward'
  ],
  'Rugby': [
    'Prop', 'Hooker', 'Lock', 'Flanker', 'Number 8', 'Scrum Half', 'Fly Half',
    'Center', 'Wing', 'Fullback'
  ],
  'Cricket': [
    'Wicket Keeper', 'Batsman', 'Bowler', 'All Rounder', 'Captain'
  ],
  'Golf': [
    'Individual Player'
  ],
  'Wrestling': [
    'Heavyweight', 'Light Heavyweight', 'Middleweight', 'Welterweight', 'Lightweight'
  ],
  'Gymnastics': [
    'All Around', 'Floor', 'Pommel Horse', 'Still Rings', 'Vault', 'Parallel Bars', 'High Bar',
    'Uneven Bars', 'Balance Beam'
  ],
  'Cross Country': [
    'Distance Runner'
  ],
  'Cheerleading': [
    'Flyer', 'Base', 'Back Spot', 'Front Spot', 'Tumbler'
  ]
};

export const getPositionsForSport = (sport: string): string[] => {
  return SPORT_POSITIONS[sport] || ['Player'];
};

export const getAllSports = (): string[] => {
  return Object.keys(SPORT_POSITIONS);
};